// Contenu de présentation (mini-tuto + lien d'action) par étape du suivi d'audit.
// Séparé du backend car ce sont des données éditoriales, pas des calculs.
export const STAGE_CONFIG = {
    building_info: {
        tutorial: "Renseignez les informations générales du bâtiment : adresse, surface, prix de l'eau et de l'énergie, contacts de l'audit.",
        ctaLabel: "Compléter les informations",
        getRoute: ({ clientId, buildingId }) => `/audit/${clientId}/${buildingId}`,
    },
    sections_rooms: {
        tutorial: "Créez les sections et les pièces du bâtiment pour pouvoir y rattacher les équipements.",
        ctaLabel: "Gérer les sections et pièces",
        getRoute: ({ clientId, buildingId }) => `/audit/${clientId}/${buildingId}`,
    },
    onsite_audit: {
        tutorial: "Sur place, ajoutez chaque équipement (robinet, WC, douche...) avec ses caractéristiques techniques, une photo et vos notes.",
        ctaLabel: "Aller à l'audit terrain",
        getRoute: ({ clientId, buildingId }) => `/audit/${clientId}/${buildingId}`,
    },
    domestic_usages: {
        tutorial: "Répartissez les usagers déclarés (agents, visiteurs...) sur les équipements via l'onglet Usages > Répartition.",
        ctaLabel: "Répartir les usagers",
        getRoute: ({ buildingId }) => `/client/${buildingId}/usages?open=distribution`,
    },
    specific_usages: {
        tutorial: "Vérifiez que chaque équipement a au moins un usage renseigné (arrosage, process, etc.).",
        ctaLabel: "Vérifier les usages",
        getRoute: ({ buildingId }) => `/client/${buildingId}/usages`,
    },
    consumption_coherence: {
        tutorial: "Comparez la consommation réelle (facture) à l'estimation calculée ; l'écart cible est inférieur à 10%.",
        ctaLabel: "Voir le tableau de bord",
        getRoute: ({ clientId, buildingId }) => `/client/${clientId}/${buildingId}`,
    },
    equipment_rating: {
        tutorial: "Vérifiez que chaque équipement a bien une note calculée ; complétez les champs techniques manquants sinon.",
        ctaLabel: "Voir les équipements",
        getRoute: ({ buildingId }) => `/client/${buildingId}/equipments`,
    },
    solutions: {
        tutorial: "Fonctionnalité à venir : le chiffrage des solutions d'économie sera bientôt disponible ici.",
        ctaLabel: null,
        getRoute: () => null,
    },
};
